import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { DashboardService } from 'src/app/services/dashboard/dashboard.service';
import calculoZoom from '../../dashboard/calculoDistancias';


import * as L from 'leaflet';
import 'leaflet-control-geocoder';
import { ActivatedRoute, Router } from '@angular/router';
import { DeviceService } from 'src/app/services/devices/device.service';
import { isRelaySchedulerSerial, getRelayDeviceImage } from 'src/app/services/devices/device-type.util';
import { TranslateService } from '@ngx-translate/core';
import { ConnectorState } from 'src/assets/js/constants';


@Component({
    selector: 'app-map-group',
    templateUrl: './map-group.component.html',
    styleUrls: ['./map-group.component.scss'],
    standalone: false
})
export class MapGroupComponent implements OnChanges {

  @Input() loading: any = null;
  @Input() data: any = {}
  devices: any = [];
  map: any;
  marker: any;
  address: string = '';
  locations: any = [];
  latitud: number = 0;
  longitud: number = 0;
  myZoom: any;
  group: string = '';
  connectors: any;
  connectorsState: any[] = [];
  statesPermission = [5, 6, 7];
  permission: any[] = [];
  totalPower: any;
  homePower: any;
  evsePower: any;
  fvPower: any;
  battEnergy: number;
  batteryCharging: boolean;
  battPercent: any;
  solarInfo: any;
  popup: any;
  loadingInfo: boolean = false;
  info: boolean = false;
  serial: string = '';
  indice: number;
  allStates = ConnectorState;
  channels: any;

  icono =
    '<div class="text-center m-2 "><svg xmlns="http://www.w3.org/2000/svg" height="30px"  width="30px" fill="currentColor" viewBox="0 0 576 512"><!--!Font Awesome Free 6.5.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.--><path d="M96 0C60.7 0 32 28.7 32 64V448c-17.7 0-32 14.3-32 32s14.3 32 32 32H320c17.7 0 32-14.3 32-32s-14.3-32-32-32V304h16c22.1 0 40 17.9 40 40v32c0 39.8 32.2 72 72 72s72-32.2 72-72V252.3c32.5-10.2 56-40.5 56-76.3V144c0-8.8-7.2-16-16-16H544V80c0-8.8-7.2-16-16-16s-16 7.2-16 16v48H480V80c0-8.8-7.2-16-16-16s-16 7.2-16 16v48H432c-8.8 0-16 7.2-16 16v32c0 35.8 23.5 66.1 56 76.3V376c0 13.3-10.7 24-24 24s-24-10.7-24-24V344c0-48.6-39.4-88-88-88H320V64c0-35.3-28.7-64-64-64H96zM216.9 82.7c6 4 8.5 11.5 6.3 18.3l-25 74.9H256c6.7 0 12.7 4.2 15 10.4s.5 13.3-4.6 17.7l-112 96c-5.5 4.7-13.4 5.1-19.3 1.1s-8.5-11.5-6.3-18.3l25-74.9H96c-6.7 0-12.7-4.2-15-10.4s-.5-13.3 4.6-17.7l112-96c5.5-4.7 13.4-5.1 19.3-1.1z"/></svg></div> ';
  iconoANC =
    '<div class="text-center m-1 "><svg xmlns="http://www.w3.org/2000/svg" height="30px"  width="30px" fill="currentColor" viewBox="0 0 600 600"><!--!Font Awesome Free v7.1.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc.--><path d="M420.9 448C428.2 425.7 442.8 405.5 459.3 388.1C492 353.7 512 307.2 512 256C512 150 426 64 320 64C214 64 128 150 128 256C128 307.2 148 353.7 180.7 388.1C197.2 405.5 211.9 425.7 219.1 448L420.8 448zM416 496L224 496L224 512C224 556.2 259.8 592 304 592L336 592C380.2 592 416 556.2 416 512L416 496zM312 176C272.2 176 240 208.2 240 248C240 261.3 229.3 272 216 272C202.7 272 192 261.3 192 248C192 181.7 245.7 128 312 128C325.3 128 336 138.7 336 152C336 165.3 325.3 176 312 176z"/></svg></div> ';
  iconoCTM =
    '<div class="text-center m-1 "><svg xmlns="http://www.w3.org/2000/svg" height="30px"  width="30px" fill="currentColor" viewBox="0 0 600 600"><!--!Font Awesome Free v7.1.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc.--><path d="M169.3 256C196.8 163.5 282.5 96 384 96L448 96C465.7 96 480 110.3 480 128C480 145.7 465.7 160 448 160L384 160C318.4 160 262 199.5 237.3 256L368 256C381.3 256 392 266.7 392 280C392 293.3 381.3 304 368 304L224.8 304C224.3 309.3 224 314.6 224 320C224 325.4 224.3 330.7 224.8 336L368 336C381.3 336 392 346.7 392 360C392 373.3 381.3 384 368 384L237.3 384C262 440.5 318.4 480 384 480L448 480C465.7 480 480 494.3 480 512C480 529.7 465.7 544 448 544L384 544C282.5 544 196.8 476.5 169.3 384L136 384C122.7 384 112 373.3 112 360C112 346.7 122.7 336 136 336L160.6 336C159.9 325.5 159.9 314.5 160.6 304L136 304C122.7 304 112 293.3 112 280C112 266.7 122.7 256 136 256L169.3 256z"/></svg></div> ';

  divLoading =
    '<div class="text-center mb-1">  <div id="loading"  class="spinner-border text-primary spinner" role="status" ><span class="visually-hidden"></span></div> </div> ';



  constructor(
    private _dashboardService: DashboardService,
    private _router: Router,
    private _devices: DeviceService,
    private route: ActivatedRoute,
    private _translate: TranslateService,

  ) { }

  ngOnInit() { }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['data']) {
      console.log('data in mapgroup ', this.data);
      this.devices = this.data?.devices ?? [];
      this.initMap();
    }
  }


  initMap() {
    if (this.map) {
      this.map.remove();
    }
    this.locations = []
    console.log('devices en grupo ', this.devices);

    // Filtrar dispositivos que tienen coordenadas
    const devicesWithCoords = this.devices.filter(device => device.coords);
    console.log('devices with coords ', devicesWithCoords);

    if (devicesWithCoords && devicesWithCoords.length > 0) {
      devicesWithCoords.forEach(device => {
        const [latitud, longitud] = JSON.parse(device.coords);
        this.locations.push({ position: { lat: latitud, lng: longitud } });
      })

      this.myZoom = calculoZoom(this.locations);
      const [latitud, longitud] = JSON.parse(devicesWithCoords[0].coords);
      this.map = L.map('map', {
        scrollWheelZoom: true,
        zoomControl: false,
      }).setView([latitud, longitud], this.myZoom);

      // Añade capa base
      L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png?', {
        attribution: '&copy; OpenStreetMap contributors'
      }).addTo(this.map);


      // Crear grupo de clustering para marcadores
      const markerClusterGroup = (L as any).markerClusterGroup({
        // Configuración del clustering
        maxClusterRadius: 80, // Radio máximo para agrupar marcadores
        spiderfyOnMaxZoom: true, // Desagrupar al hacer zoom máximo
        showCoverageOnHover: false, // No mostrar área de cobertura al hover
        zoomToBoundsOnClick: true, // Zoom automático por defecto al hacer click
        // Personalizar el icono del cluster
        iconCreateFunction: function (cluster) {
          const childCount = cluster.getChildCount();
          let clusterClass = 'marker-cluster-';

          if (childCount < 10) {
            clusterClass += 'small';
          } else if (childCount < 100) {
            clusterClass += 'medium';
          } else {
            clusterClass += 'large';
          }

          return new L.DivIcon({
            html: '<div><span>' + childCount + '</span></div>',
            className: 'marker-cluster ' + clusterClass,
            iconSize: new L.Point(40, 40)
          });
        }
      });

      // Marcadores solo para dispositivos con coordenadas
      devicesWithCoords.forEach((device, i) => {
        const [latitud, longitud] = JSON.parse(device.coords);

        const isAlive = device.alive !== 0;
        let backgroundColor = '';
        let circleColor = '';

        if(!device.channels){
          console.log('no hay device.channels', device.channels);

           backgroundColor = isAlive ? '#33c88c' : '#ff4c4c';
           circleColor = isAlive ? '#269568' : '#a50404';
        }
        if(device.channels){
                    console.log('SI hay device.channels', device.channels);

          if(device.channels.c1stat == 2 || device.channels.c1stat == 3 || device.channels.c2stat == 2 || device.channels.c2stat == 3){
             backgroundColor = '#f7d21a';
            circleColor = '#CAA907';
          }
          else{
    backgroundColor = '#808080';
          circleColor = '#696969';
        }

        }

        var iconHtml = `
        <svg width="30" height="40" viewBox="0 0 26 36" xmlns="http://www.w3.org/2000/svg">
          <!-- Gota de fondo -->
          <path fill="${backgroundColor}" d="M13.0167 35C12.7836 35 12.7171 34.9346 12.3176 33.725C11.9848 32.6789 11.4854 31.0769 10.1873 29.1154C8.92233 27.1866 7.59085 25.6173 6.32594 24.1135C3.36339 20.5174 1 17.7057 1 12.6385C1.03329 6.19808 6.39251 1 13.0167 1C19.6408 1 25 6.23078 25 12.6385C25 17.7057 22.6699 20.55 19.6741 24.1462C18.4425 25.65 17.1443 27.2193 15.8793 29.1154C14.6144 31.0442 14.0818 32.6135 13.749 33.6596C13.3495 34.9346 13.2497 35 13.0167 35Z"/>

          <!-- Círculo interior -->
          <circle cx="13" cy="13" r="10" fill="${circleColor}" />

          <!-- Icono SVG insertado dentro del círculo -->
          <g transform="translate(10, 6) scale(0.018, 0.024)">
            <path fill="white" d="M0 256L28.5 28c2-16 15.6-28 31.8-28H228.9c15 0 27.1 12.1 27.1 27.1c0 3.2-.6 6.5-1.7 9.5L208 160H347.3c20.2 0 36.7 16.4 36.7 36.7c0 7.4-2.2 14.6-6.4 20.7l-192.2 281c-5.9 8.6-15.6 13.7-25.9 13.7h-2.9c-15.7 0-28.5-12.8-28.5-28.5c0-2.3 .3-4.6 .9-6.9L176 288H32c-17.7 0-32-14.3-32-32z"/>
          </g>
        </svg>
        `;

      if(this.isRelaySchedulerSerial(device.serial) || device.serial.startsWith('XLUM')) {
        iconHtml = `
        <svg width="30" height="40" viewBox="0 0 26 36" xmlns="http://www.w3.org/2000/svg">
          <!-- Gota de fondo -->
          <path fill="${backgroundColor}" d="M13.0167 35C12.7836 35 12.7171 34.9346 12.3176 33.725C11.9848 32.6789 11.4854 31.0769 10.1873 29.1154C8.92233 27.1866 7.59085 25.6173 6.32594 24.1135C3.36339 20.5174 1 17.7057 1 12.6385C1.03329 6.19808 6.39251 1 13.0167 1C19.6408 1 25 6.23078 25 12.6385C25 17.7057 22.6699 20.55 19.6741 24.1462C18.4425 25.65 17.1443 27.2193 15.8793 29.1154C14.6144 31.0442 14.0818 32.6135 13.749 33.6596C13.3495 34.9346 13.2497 35 13.0167 35Z"/>

          <!-- Círculo interior -->
          <circle cx="13" cy="13" r="10" fill="${circleColor}" />

          <!-- Icono SVG insertado dentro del círculo -->
          <g transform="translate(5,5) scale(0.024, 0.024)">
            <path fill="#ffffff" d="M420.9 448C428.2 425.7 442.8 405.5 459.3 388.1C492 353.7 512 307.2 512 256C512 150 426 64 320 64C214 64 128 150 128 256C128 307.2 148 353.7 180.7 388.1C197.2 405.5 211.9 425.7 219.1 448L420.8 448zM416 496L224 496L224 512C224 556.2 259.8 592 304 592L336 592C380.2 592 416 556.2 416 512L416 496zM312 176C272.2 176 240 208.2 240 248C240 261.3 229.3 272 216 272C202.7 272 192 261.3 192 248C192 181.7 245.7 128 312 128C325.3 128 336 138.7 336 152C336 165.3 325.3 176 312 176z"/>
          </g>
        </svg>
        `;
      }

      if(device.serial.startsWith('CTM')) {
        iconHtml = `
        <svg width="30" height="40" viewBox="0 0 26 36" xmlns="http://www.w3.org/2000/svg">
          <!-- Gota de fondo -->
          <path fill="${backgroundColor}" d="M13.0167 35C12.7836 35 12.7171 34.9346 12.3176 33.725C11.9848 32.6789 11.4854 31.0769 10.1873 29.1154C8.92233 27.1866 7.59085 25.6173 6.32594 24.1135C3.36339 20.5174 1 17.7057 1 12.6385C1.03329 6.19808 6.39251 1 13.0167 1C19.6408 1 25 6.23078 25 12.6385C25 17.7057 22.6699 20.55 19.6741 24.1462C18.4425 25.65 17.1443 27.2193 15.8793 29.1154C14.6144 31.0442 14.0818 32.6135 13.749 33.6596C13.3495 34.9346 13.2497 35 13.0167 35Z"/>

          <!-- Círculo interior -->
          <circle cx="13" cy="13" r="10" fill="${circleColor}" />

          <!-- Icono SVG insertado dentro del círculo -->
          <g transform="translate(4,5) scale(0.026, 0.024)">
            <path fill="#ffffff" d="M169.3 256C196.8 163.5 282.5 96 384 96L448 96C465.7 96 480 110.3 480 128C480 145.7 465.7 160 448 160L384 160C318.4 160 262 199.5 237.3 256L368 256C381.3 256 392 266.7 392 280C392 293.3 381.3 304 368 304L224.8 304C224.3 309.3 224 314.6 224 320C224 325.4 224.3 330.7 224.8 336L368 336C381.3 336 392 346.7 392 360C392 373.3 381.3 384 368 384L237.3 384C262 440.5 318.4 480 384 480L448 480C465.7 480 480 494.3 480 512C480 529.7 465.7 544 448 544L384 544C282.5 544 196.8 476.5 169.3 384L136 384C122.7 384 112 373.3 112 360C112 346.7 122.7 336 136 336L160.6 336C159.9 325.5 159.9 314.5 160.6 304L136 304C122.7 304 112 293.3 112 280C112 266.7 122.7 256 136 256L169.3 256z"/>
          </g>
        </svg>
        `;
      }

        const myIcon = L.divIcon({
          className: '',
          html: iconHtml,
          iconSize: [30, 40],
          iconAnchor: [15, 40]
        });



        const marker = L.marker([latitud, longitud], { icon: myIcon })
        marker.bindTooltip(device.name);
        marker.on('click', () => {
          this.info = false;
          this.loadingInfo = true;
          this.popup = L.popup()
            .setLatLng(marker.getLatLng())
            .setContent(device.name + `<br>` + `<small>` + device.serial + `</small>` + this.divLoading)
            .openOn(this.map);
          this.serial = device.serial;
          this.indice = i;
          this.getData(this.serial, device.name);
        });
        // Añadir el marcador al grupo de clustering en lugar de directamente al mapa
        markerClusterGroup.addLayer(marker);
        // Añadir el grupo de clustering al mapa
        this.map.addLayer(markerClusterGroup);
      });

      // Información sobre dispositivos sin ubicación
      const devicesWithoutLocation = this.devices.length - devicesWithCoords.length;
      if (devicesWithoutLocation > 0) {
        console.info(`${devicesWithoutLocation} device(s) don't have location data and won't be displayed on the map`);

        // Mostrar popup temporal de advertencia
        this.showTemporaryWarning(devicesWithoutLocation);
      }

    } else {
      // No hay dispositivos con ubicación
      this.mapWithoutDevices();

      if (this.devices && this.devices.length > 0) {
        console.info(`All ${this.devices.length} device(s) don't have location data`);
      }
    }
  }

  showTemporaryWarning(devicesWithoutLocation: number) {
    const warningContent = `
      <div class="text-center p-2" style="background: #fff3cd; border: 1px solid #ffeaa7; border-radius: 4px;">
        <i class="fas fa-exclamation-triangle text-warning fa-lg mb-2"></i>
        <h6 class="text-warning mb-1">${this._translate.instant('warning')}</h6>
        <p class="mb-0 small text-dark">
          ${devicesWithoutLocation} ${this._translate.instant(devicesWithoutLocation > 1 ? 'devices' : 'device')}
          ${this._translate.instant('noLocationData')}
        </p>
      </div>
    `;

    const warningPopup = L.popup({
      closeButton: true,
      autoClose: false,
      closeOnEscapeKey: true,
      closeOnClick: false,
      className: 'warning-popup'
    })
    .setLatLng([40.4165, -3.70256])
    .setContent(warningContent)
    .openOn(this.map);

    // Cerrar automáticamente después de 4 segundos
    setTimeout(() => {
      if (this.map && warningPopup.isOpen()) {
        this.map.closePopup(warningPopup);
      }
    }, 4000);
  }

  mapWithoutDevices() {
    this.map = L.map('map', {
      scrollWheelZoom: false,
      zoomControl: false,
    }).setView([40.4165, -3.70256], 6);

    // Añade capa base
    L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png?', {
      attribution: '&copy; OpenStreetMap contributors'
    }).addTo(this.map);

    // Agregar mensaje informativo en el centro del mapa
    const messageContent = this.devices && this.devices.length > 0
      ? `<div class="text-center p-3">
           <i class="fas fa-map-marker-alt fa-2x text-muted mb-2"></i>
           <h5 class="text-muted">${this._translate.instant('noLocationData')}</h5>
           <p class="text-muted mb-0">${this._translate.instant('devicesNoLocationInfo')}</p>
         </div>`
      : `<div class="text-center p-3">
           <i class="fas fa-map fa-2x text-muted mb-2"></i>
           <h5 class="text-muted">${this._translate.instant('noDevices')}</h5>
           <p class="text-muted mb-0">${this._translate.instant('groupNoDevices')}</p>
         </div>`;

    L.popup({
      closeButton: false,
      autoClose: false,
      closeOnEscapeKey: false,
      closeOnClick: false,
      className: 'no-devices-popup'
    })
    .setLatLng([40.4165, -3.70256])
    .setContent(messageContent)
    .openOn(this.map);
  }

  getData(serial: string, name: string): void {

    if(!this.isRelaySchedulerSerial(serial) || serial.startsWith('XLUM')) {
      this._devices.getMultiModules(serial, ['evsm', 'modulator', 'solar'], 'all', true).subscribe(data => {
        data.forEach(module => {

          switch (module.topic_name) {

            case "evsm":
              this.connectors = module.elements;
              this.connectors.forEach((conn, i) => {
                this.connectorsState[i] = conn.data.stat.state;
                if (this.statesPermission.includes(this.connectorsState[i]))
                  this.permission[i] = true;
                else this.permission[i] = false;
              });
              break;

            case "modulator":
              this.totalPower = module.stat.instPower;
              this.homePower = module.stat.homePower;
              this.evsePower = module.stat.evsePower;
              this.fvPower = module.stat.fvPower;
              if (module.stat.battEnergy < 0) {
                this.battEnergy = -1 * module.stat.battEnergy;
                this.batteryCharging = true;
              } else {
                this.battEnergy = module.stat.battEnergy;
                this.batteryCharging = false;
              }
              this.battPercent = module.stat.battPercent;
              break;

            case "solar":
              this.solarInfo = module;
              if (typeof this.solarInfo?.cfg?.inversor === 'string')
                this.solarInfo.cfg.inversor = JSON.parse(this.solarInfo.cfg.inversor);
              break;
            default:
              break;
          }
        });
      });
    }
        if (this.isRelaySchedulerSerial(serial) || serial.startsWith('XLUM')) {
      this._devices.getModuleInfo(serial, 'channel').subscribe(data => {
        this.channels = data.stat;
        console.log('info channels ', this.channels);

      })
    }

    setTimeout(() => {
      if(this.isRelaySchedulerSerial(serial) || serial.startsWith('XLUM')) {
        this.popup.setContent(name + `<br>` + `<small>` + serial + `</small>` + this.iconoANC);
      }
      else if(serial.startsWith('CTM')) {
        this.popup.setContent(name + `<br>` + `<small>` + serial + `</small>` + this.iconoCTM);
      }
      else{
        this.popup.setContent(name + `<br>` + `<small>` + serial + `</small>` + this.icono);
      }
      this.loadingInfo = false;
      this.info = true;
    }, 1500);
  }

  closeInfoPanel() {
    this.info = false;
    this.map.closePopup();
  }

  getTranslatedText(translationKey: string) {
    if (translationKey) return this._translate.instant(translationKey);
    else return null;
  }

  goToDevice(serial) {
    this._router.navigateByUrl(`/dashboard/device/${serial}`);
  }
  goToSettings(serial) {
    this._router.navigateByUrl(`/dashboard/device/${serial}/settings`);
  }

  goToDiagnosis(serial) {
    this._router.navigateByUrl(`/dashboard/device/${serial}/diagnosis`);
  }

  isRelaySchedulerSerial(serial: string): boolean {
    return isRelaySchedulerSerial(serial);
  }

  getRelayDeviceImage(serial: string, subType?: string): string {
    return getRelayDeviceImage(serial, subType);
  }
}
